/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dispatch, RefObject, SetStateAction, useEffect } from "react";

const useOutsideClick = (
  ref: RefObject<HTMLDivElement>,
  stateSetter: Dispatch<SetStateAction<boolean>>
): void => {
  useEffect(() => {
    const handleClickOutside = (event: any): void => {
      if (ref.current && !ref.current.contains(event.target)) {
        stateSetter(false);
      }
    };
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, stateSetter]);
};

export default useOutsideClick;
